/**
 * SettingsDataProvider - Provides settings (including theme) for popup windows
 * 
 * This component runs in the main window and handles POPUP_INIT requests
 * for settings popups. It sends date format, timezone, and theme.
 */
import { useCallback } from 'react';
import {
  usePopupMessages,
  MainWindowActions,
  MessageType,
  PopupMessage,
} from './PopupEvents';
import { useSettings } from '../Settings/SettingsProvider';
import { useThemeMode } from '../../configuration/ThemeProvider';

export const SettingsDataProvider = (): null => {
  const { settings } = useSettings();
  const { theme } = useThemeMode();

  // Handle settings init requests from popups
  usePopupMessages(
    useCallback(
      (msg: PopupMessage) => {
        if (msg.type !== MessageType.POPUP_INIT) return;

        const payload = msg.payload as { popupId: string; popupType: string };
        if (payload.popupType !== 'settings') return;

        const { popupId } = payload;

        // Send settings response including theme
        MainWindowActions.sendInitResponse(popupId, {
          dateFormat: settings['ribbonPlugin.settings']?.date_format_mp,
          timeZone: settings['ribbonPlugin.settings']?.time_zone,
          theme,
        });
      },
      [settings, theme]
    ),
    [settings, theme]
  );

  return null;
};
